module.exports = __webpack_public_path__ + "assets/logo_navbar.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_navbar.jpg
 ** module id = 15
 ** module chunks = 1
 **/